/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileStoreDetails } from './StoreProfileStoreDetails';
import {
    StoreProfileStoreDetailsFromJSON,
    StoreProfileStoreDetailsFromJSONTyped,
    StoreProfileStoreDetailsToJSON,
    StoreProfileStoreDetailsToJSONTyped,
} from './StoreProfileStoreDetails';

/**
 * 
 * @export
 * @interface ChangeRequestDetails
 */
export interface ChangeRequestDetails {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDetails
     */
    storeProfileId?: string;
    /**
     * 
     * @type {ChangeRequestDetailsApprovalStatusEnum}
     * @memberof ChangeRequestDetails
     */
    approvalStatus: ChangeRequestDetailsApprovalStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ChangeRequestDetails
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChangeRequestDetails
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeRequestDetails
     */
    storeProfileVisibleAfterApproval?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestDetails
     */
    rejectionReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeRequestDetails
     */
    draft: boolean;
    /**
     * 
     * @type {StoreProfileStoreDetails}
     * @memberof ChangeRequestDetails
     */
    store: StoreProfileStoreDetails;
}


/**
 * @export
 */
export const ChangeRequestDetailsApprovalStatusEnum = {
    InReview: 'IN_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED'
} as const;
export type ChangeRequestDetailsApprovalStatusEnum = typeof ChangeRequestDetailsApprovalStatusEnum[keyof typeof ChangeRequestDetailsApprovalStatusEnum];


/**
 * Check if a given object implements the ChangeRequestDetails interface.
 */
export function instanceOfChangeRequestDetails(value: object): value is ChangeRequestDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('approvalStatus' in value) || value['approvalStatus'] === undefined) return false;
    if (!('draft' in value) || value['draft'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function ChangeRequestDetailsFromJSON(json: any): ChangeRequestDetails {
    return ChangeRequestDetailsFromJSONTyped(json, false);
}

export function ChangeRequestDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'storeProfileId': json['storeProfileId'] == null ? undefined : json['storeProfileId'],
        'approvalStatus': json['approvalStatus'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'storeProfileVisibleAfterApproval': json['storeProfileVisibleAfterApproval'] == null ? undefined : json['storeProfileVisibleAfterApproval'],
        'rejectionReason': json['rejectionReason'] == null ? undefined : json['rejectionReason'],
        'draft': json['draft'],
        'store': StoreProfileStoreDetailsFromJSON(json['store']),
    };
}

export function ChangeRequestDetailsToJSON(json: any): ChangeRequestDetails {
    return ChangeRequestDetailsToJSONTyped(json, false);
}

export function ChangeRequestDetailsToJSONTyped(value?: ChangeRequestDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'storeProfileId': value['storeProfileId'],
        'approvalStatus': value['approvalStatus'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'storeProfileVisibleAfterApproval': value['storeProfileVisibleAfterApproval'],
        'rejectionReason': value['rejectionReason'],
        'draft': value['draft'],
        'store': StoreProfileStoreDetailsToJSON(value['store']),
    };
}

